<div class="error-container" [class.rtl]="rtl">
  <h1>{{ "errors." + code + ".title" | translate }}</h1>
  <p>{{ "errors." + code + ".message" | translate }}</p>

  <div class="actions">
    <button (click)="goHome()">
      {{ "errors.actions.home" | translate }}
    </button>
    <button (click)="retry()">
      {{ "errors.actions.retry" | translate }}
    </button>
  </div>
</div>
